import React from "react"
import Row from "react-bootstrap/Row"

const CardGrid = ({ heading, items }) => {
  return items ? (
    <section className="block-follows-heading base-margin-top-xl base-margin-bottom-large text-align-left">
      {heading && (
        <div className="base-margin-bottom-small">
          <h2>{heading}</h2>
        </div>
      )}
      <Row className="mobile-bottom-margins">{items}</Row>
    </section>
  ) : (
    ""
  )
}

export default CardGrid
